import Axios from "axios";

export default function getResult(loginId){
    //console.log(loginUserId,trackId,selectedType,selectedEntrance);
    let response = Axios.get(process.env.REACT_APP_GATEWAY_URL, {
        params: {
            a: 'getResult',
             loginId
        }
    });
    return response;
}